import { render, staticRenderFns } from "./OpcionDialogEdit.vue?vue&type=template&id=515687b5"
import script from "./OpcionDialogEdit.vue?vue&type=script&lang=js"
export * from "./OpcionDialogEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports